import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/tenvicCommon/FunctionCalls";
import * as api from "../../common/tenvicCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import Utils from "../../common/tenvicCommon/Utils";

const UserRoleMenuPermission = () => {

    const [rbacList, setRbacList] = useState<any[]>([]);
    const [rolesList, setRolesList] = useState<any[]>([]);
    const [menuList, setMenuList] = useState<any[]>([]);
    const [submenuList, setSubmenuList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [roleId, setRoleId] = useState("");
    const [menuId, setMenuId] = useState("");
    const [rleMnuPmsn, setRleMnuPmsn] = useState("");
    const [rleMnuStatus, setRleMnuStatus] = useState("");
    const [subMenuId, setSubMenuId] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchUserRbac() {
            setIsLoading(true);
            const rbacResponse = await func.listUserRBAC();
            setRbacList(Array.isArray(rbacResponse) ? rbacResponse : [])
            setIsLoading(false);
        }
        fetchUserRbac();
    }, [])

    const filteredData = rbacList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.internalRoleName}</span>;
    };

    const menuRender = (rowData) => {
        return <span>{rowData.internalMenuTitle}</span>;
    };

    const subMenuRender = (rowData) => {
        return <span>{rowData.internalSubmenuTitle}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.internalRoleMenuPermissionStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editUserRBAC(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const rlemnupmsnId = rowData.internalRoleMenuPermissionId;
        return (
            <Link to="#" onClick={() => deleteRBAC(rlemnupmsnId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newRBAC() {
        setIsEdit(false)
        setOpenModal(true)
        const rleResponse = await func.listRoles();
        setRolesList(Array.isArray(rleResponse) ? rleResponse : [])
        setRoleId("")
        setMenuId("")
        setSubMenuId([])
    }


    async function editUserRBAC(rowData: { internalRoleMenuPermissionId: string | number; }) {
        const rbacId = rowData.internalRoleMenuPermissionId;
        setIsEdit(true)
        setOpenModal(true)
        const mnuResponse = await func.listMenus();
        setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
        const sbmnuResponse = await func.listSubMenus();
        setSubmenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
        const getDetails = await func.getUserRBAC(rbacId);
        setRleMnuPmsn(getDetails.internalRoleMenuPermissionId);
        setRoleId(getDetails.internalRoleId)
        setMenuId(getDetails.internalMenuId)
        setSubMenuId(getDetails.internalSubMenuId)
        setRleMnuStatus(getDetails.internalRoleMenuPermissionStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateRBAC();
            } else {
                if (roleId && menuId && subMenuId) {
                    const formData = new FormData();
                    formData.append("roleId", roleId);
                    formData.append("menuId", JSON.stringify([Number(menuId)]));
                    formData.append("subMenuId", JSON.stringify(subMenuId.map(Number)));

                    // formData.forEach((value, key) => {
                    //     console.log(`${key}: ${value}`);
                    // });
                    const createRBAC = api.CreateUserRBAC;
                    fetch(createRBAC, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateRBAC() {
        const formData = new FormData();
        formData.append("roleId", roleId);
        formData.append("menuId", menuId);
        formData.append("subMenuId", JSON.stringify(subMenuId.map(Number)));
        formData.append("status", rleMnuStatus);

        const updateRoleMnuPmsn = api.UpdateUserRBAC + '/' + rleMnuPmsn;
        fetch(updateRoleMnuPmsn, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                45
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteRBAC(rlemnupmsnId: string) {
        const deleteRole = api.DeleteRole + '/' + rlemnupmsnId;
        fetch(deleteRole, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Roles</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn btn-secondary"
                                            onClick={() => { newRBAC() }}>
                                            <i className="feather-plus" />&nbsp;
                                            Create User RBAC
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalRoleName"
                                                header="Role Name"
                                                body={roleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalMenuTitle"
                                                header="Menu Name"
                                                body={menuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalSubmenuTitle"
                                                header="Sub Menu Name"
                                                body={subMenuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalRoleMenuPermissionStatus"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} RBAC</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Role Name</label>
                                        <Select
                                            value={rolesList.find(role => role.internalRoleId === roleId) ? {
                                                value: roleId,
                                                label: rolesList.find(role => role.internalRoleId === roleId).internalRoleName
                                            } : null}
                                            onChange={async (e) => {
                                                setRoleId(e.value);
                                                const mnuResponse = await func.listMenus();
                                                setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
                                            }}
                                            isDisabled={isEdit}
                                            required
                                            placeholder="Select Role"
                                            options={rolesList.map(role => ({
                                                value: role.internalRoleId,
                                                label: role.internalRoleName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Menu Name</label>
                                        <Select
                                            value={menuList.find(menu => menu.internalMenuId === menuId) ? {
                                                value: menuId,
                                                label: menuList.find(menu => menu.internalMenuId === menuId).internalMenuTitle
                                            } : null}
                                            onChange={async (e) => {
                                                setMenuId(e.value);
                                                const sbmnuResponse = await func.getSubmenusByMenu(e.value);
                                                setSubmenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
                                            }}
                                            isDisabled={isEdit}
                                            required
                                            placeholder="Select Menu"
                                            options={menuList.map(menu => ({
                                                value: menu.internalMenuId,
                                                label: menu.internalMenuTitle
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">SubMenu Name</label>
                                        <Select
                                            isMulti={!isEdit}
                                            value={Array.isArray(submenuList)
                                                ? submenuList
                                                    .filter(submenu => subMenuId.includes(submenu.internalSubmenuId))
                                                    .map(submenu => ({
                                                        value: submenu.internalSubmenuId,
                                                        label: submenu.internalSubmenuTitle
                                                    }))
                                                : []
                                            }
                                            onChange={(selectedOptions) => {
                                                // const selectedIds = selectedOptions.map(option => option.value);
                                                const selectedIds = Array.isArray(selectedOptions)
                                                    ? selectedOptions.map(option => option.value)
                                                    : selectedOptions
                                                        ? [selectedOptions.value]
                                                        : [];
                                                setSubMenuId(selectedIds);
                                            }}
                                            options={Array.isArray(submenuList)
                                                ? submenuList.map(submenu => ({
                                                    value: submenu.internalSubmenuId,
                                                    label: submenu.internalSubmenuTitle
                                                }))
                                                : []
                                            }
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={rleMnuStatus === '1'}
                                                        id="permissionStatus"
                                                        onChange={(e) => {
                                                            setRleMnuPmsn(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default UserRoleMenuPermission;